import { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { Home, BookOpen, Truck, Star, ShoppingBag } from "lucide-react";
import { useCart } from "../context/CartContext";

const items = [
  { to: "/", icon: Home, label: "Home", id: "home" },
  { to: "/menu", icon: BookOpen, label: "Menu", id: "menu" },
  { to: "/track", icon: Truck, label: "Track", id: "track" },
  { to: "/reviews", icon: Star, label: "Reviews", id: "reviews" },
];

export const MobileBottomNav = () => {
  const { pathname } = useLocation();
  const { count, openCart } = useCart();
  const [footerVisible, setFooterVisible] = useState(false);

  // Hide the floating cart pill when the footer scrolls into view so it
  // doesn't cover up the admin link or other footer content.
  useEffect(() => {
    const footer = document.querySelector('[data-testid="site-footer"]');
    if (!footer || !("IntersectionObserver" in window)) return;
    const obs = new IntersectionObserver(
      ([entry]) => setFooterVisible(entry.isIntersecting),
      { rootMargin: "0px 0px -120px 0px", threshold: 0 }
    );
    obs.observe(footer);
    return () => obs.disconnect();
  }, [pathname]);

  return (
    <>
      {/* Floating cart pill — fades out when footer is visible */}
      <button
        data-testid="floating-cart-btn"
        onClick={openCart}
        aria-label="Open cart"
        aria-hidden={footerVisible}
        tabIndex={footerVisible ? -1 : 0}
        className={`lg:hidden fixed bottom-20 right-4 z-40 h-14 w-14 grid place-items-center rounded-full bg-shay-gold text-shay-navy shadow-[0_10px_30px_-10px_rgba(200,154,54,0.7)] active:scale-95 transition-all duration-300 ${
          footerVisible ? "opacity-0 pointer-events-none translate-y-2" : "opacity-100"
        }`}
      >
        <ShoppingBag size={22} strokeWidth={1.8} />
        {count > 0 && (
          <span className="absolute -top-1 -right-1 min-w-[20px] h-5 px-1 grid place-items-center text-[10px] font-semibold rounded-full bg-shay-navy text-shay-gold border border-shay-gold">
            {count}
          </span>
        )}
      </button>

      <nav
        data-testid="mobile-bottom-nav"
        className="lg:hidden fixed bottom-0 inset-x-0 z-40 bg-shay-navy/95 backdrop-blur-md border-t border-shay-gold/30 safe-bottom"
      >
        <div className="grid grid-cols-4 max-w-md mx-auto">
          {items.map(({ to, icon: Icon, label, id }) => {
            const active = pathname === to;
            return (
              <Link
                key={to}
                to={to}
                data-testid={`bottom-nav-${id}`}
                className={`flex flex-col items-center gap-1 py-3 text-[10px] uppercase tracking-widest transition-colors ${
                  active ? "text-shay-gold" : "text-shay-cream/70"
                }`}
              >
                <Icon size={20} strokeWidth={1.6} />
                <span>{label}</span>
              </Link>
            );
          })}
        </div>
      </nav>
    </>
  );
};

export default MobileBottomNav;
